<style>

header {
		background-color: #135597;
		/* padding: 10px; */
		height: 60px;
		width:100%;
		border-radius:0 0 0 40px;
		padding:3px 1em 3px 32px;
		background-image: linear-gradient(60deg,#313189 0%,#313189 60%,#32326e 60%,#32326e 80%,#262753 80%,#262753 100%);
		color: #fff;
		display:flex;
		flex-flow:row nowrap;
		align-items:center;
		justify-content: space-between;
    letter-spacing: 2px;
}

header > img{
		height:40px;
		margin-right:0.6em;
}



/* header > span {
	font-size:1.15em;
	font-weight:700;
	color:#FFF;
	opacity:0.8;
	letter-spacing:3px;
	text-align:center;
} */


/* ==================== MEDIA QUERIES =================== */
@media all and (max-width:750px)
{
	header { height:54px; }

	/* header > span { font-size:0.9em; } */

	header > img {
		height:30px;
		margin-right:0.5em;
	}

	/* header > span {
		letter-spacing:2px;
		font-size:0.9em;
	} */
}


</style>

<script>
	export let tokenId = '';

</script>

<header>
	<img src = "/token.logo.min.svg" alt = "token logo" />
	<div>
		{tokenId}
	</div>
</header>
